import React from "react";
import { X, Heart, User } from "lucide-react";
import classNames from "classnames/bind";
import styles from "./MobileMenu.module.scss";
import MobileNavigation from "../MobileNavigation/MobileNavigation";
import LanguageSelector from "../LanguageSelector/LanguageSelector";

import { useFavoritesModalStore } from "../../stores/WishList/useFavoritesModal";
import { useOpenCloseAuthModalStore } from "../../stores/Auth/useAuthModal";
import useAuthStore from "../../stores/Auth/AuthStore";
import { useNavigate } from "react-router-dom";

const cx = classNames.bind(styles);

const MobileMenu = ({
  isOpen,
  onClose,
  menuItems,
  activeMobileDropdown,
  toggleMobileDropdown,
  mobileMenuRef,
}) => {

  const { toggleFavoritesModal } = useFavoritesModalStore()
  const { toggleAuthModal } = useOpenCloseAuthModalStore()
  const {isAuthenticated} = useAuthStore()
  const navigate = useNavigate();
  const handleClickHeart = (action) => {
    onClose()
    action()
  }

  const handleClickUser = () => {
    onClose()
  if (isAuthenticated) {
      navigate('/profile');
    } else {
      toggleAuthModal();
    }  }

  return (
    <>
      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className={cx("mobile-menu__overlay")} onClick={onClose} />
      )}

      {/* Mobile Menu Sidebar */}
      <div
        ref={mobileMenuRef}
        className={cx("mobile-menu", {
          "mobile-menu--open": isOpen,
        })}
      >
        <div className={cx("mobile-menu__header")}>
          <h2 className={cx("mobile-menu__title")}>Menu</h2>
          <button className={cx("mobile-menu__close")} onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <MobileNavigation
          menuItems={menuItems}
          activeMobileDropdown={activeMobileDropdown}
          toggleMobileDropdown={toggleMobileDropdown}
          onClose={onClose}
        />

        <div className={cx("mobile-menu__icons")}>
          <button className={cx("mobile-menu__icon-button")} onClick={() => handleClickHeart(toggleFavoritesModal)}>
            <Heart size={20} />
            <span>Wishlist</span>
          </button>
          <LanguageSelector />
          <button className={cx("mobile-menu__icon-button")} onClick={() => handleClickUser()}>
            <User size={20} />
            <span>Account</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
